import { useUrlLocalizer } from 'tradera/lang/translate';
import { ListingItemWithActions } from 'tradera/apps/my-tradera/components/listing-item/listing-item-with-actions';
import { Badge } from 'tradera/apps/my-tradera/wish-list/components/badge';
import type { WishListItemCardViewModel } from 'tradera/state/services/types/webapi-member-generated';
import { useAppSelector } from 'tradera/state/hooks';
import { selectExistsInWishList } from 'tradera/state/items/selectors';
import { ActionButton } from 'tradera/apps/my-tradera/wish-list/components/action-button';

type WishListItemProps = {
    item: WishListItemCardViewModel;
    setBidHistoryItemId: (itemId: number | null) => void;
    handleWishlistClick: (itemId: number) => void;
};

export const WishListItem = ({
    item,
    setBidHistoryItemId,
    handleWishlistClick,
}: WishListItemProps) => {
    const { toLocalizedUrl } = useUrlLocalizer();

    const existsInWishlist = useAppSelector(
        selectExistsInWishList(item.itemId),
    );

    // replace imageUrl containing "medium" with "medium-fit"
    const imageUrl = item?.imageUrl?.replace('medium', 'medium-fit');

    return (
        <ListingItemWithActions
            key={item.itemId}
            grayedOut={!existsInWishlist}
            shortDescription={item?.shortDescription ?? ''}
            itemId={item.itemId}
            imageTemplate={imageUrl}
            isActive={item.isActive}
            endDate={item?.endDate}
            itemUrl={toLocalizedUrl(`/item/${item.itemId}`)}
            statusBadge={
                <div
                    style={{
                        position: 'absolute',
                        bottom: '0.5rem',
                        left: 0,
                    }}>
                    <Badge itemState={item.itemState} />
                </div>
            }
            shippingCost={item.preferredShipping.cost}
            maxBid={item.maxBidAmount || null}
            sellerAlias={item.sellerAlias}
            sellerId={item.sellerMemberId}
            bidCount={item.totalBids}
            itemPrice={item.price}
            itemType={item?.itemType}
            onShowBidHistory={setBidHistoryItemId}
            actions={<ActionButton item={item} grayedOut={!existsInWishlist} />}
            isTakeawayOnly={item.isTakeawayOnly}
            leadingBidder={null}
            onWishlistClick={handleWishlistClick}
            existsInWishlist={existsInWishlist}
        />
    );
};
